module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mtutor",
    attrs: {
      "id": "members"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "member-swiper"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.members), function(member, index) {
    return _c('swiper-slide', {
      key: ("member_" + index)
    }, [_c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": member.cover_url
      }
    }), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(member.show_name)), _c('br'), _c('span', [_vm._v(_vm._s(member.show_company))]), _vm._v(" " + _vm._s(member.show_duty))])])])
  }), 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-list-title"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v("members"), _c('br'), _vm._v("introduction")]), _c('div', {
    staticClass: "cn"
  }, [_vm._v("加入他们 成为他们")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eb3b14b6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Tutor.vue
// module id = 210
// module chunks = 1